import { apiUrl } from '../config/api'

export async function saveRetainer(params) {
  let url = apiUrl('UpdateRetainer')

  await fetch(url, { method: 'POST', body: JSON.stringify(params) })
}

export async function getRetainer(clientId) {
  let params = {
    clientId: clientId
  }

  let url = apiUrl('GetRetainerByClientId')

  return sendReq(params, url)
}

async function sendReq(params, url) {
  let res = await fetch(url, { method: 'POST', body: JSON.stringify(params) })
  return res.json()
}
